import * as React from 'react';
import { RestorationProject } from '@shapeable/kelp-forest-alliance-types';

export const RestorationProjectsContext = React.createContext<RestorationProject[]>(null);
export const RestorationProjectsProvider = RestorationProjectsContext.Provider;
